// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"258":"b2da0a96","809":"e4608b03"}[chunkId] + ".chunk.css";
};